import React, { useEffect, useState } from 'react';
import { auditoriaApi, AuditoriaLogGeral, AuditoriaModificacaoLog } from '../services/api/auditoriaService';
import { authService } from '../services/authService';

const LogsAuditoria: React.FC = () => {
  const [gerais, setGerais] = useState<AuditoriaLogGeral[]>([]);
  const [mods, setMods] = useState<AuditoriaModificacaoLog[]>([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const [limit, setLimit] = useState(50);
  const [tab, setTab] = useState<'geral' | 'modificacoes' | 'relatorio'>('geral');
  const [relatorio, setRelatorio] = useState<any[]>([]);

  async function carregar() {
    setLoading(true);
    setErro(null);
    try {
      if (tab === 'geral') {
        const dados = await auditoriaApi.listarGerais(limit);
        setGerais(dados);
      } else if (tab === 'modificacoes') {
        const dados = await auditoriaApi.listarModificacoes(limit);
        setMods(dados);
      } else {
        const dados = await auditoriaApi.relatorioCompliance();
        setRelatorio(dados);
      }
    } catch (e: any) {
      setErro(e?.friendlyMessage || 'Falha ao carregar auditoria');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    carregar();
  }, [tab, limit]);

  const usuario = authService.getUsuario();

  return (
    <section className="content pt-3">
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <h4 className="mb-0">Logs de Auditoria</h4>
            <div>
              <select value={tab} onChange={e => setTab(e.target.value as any)} className="form-control d-inline-block mr-2" style={{ width: 180 }}>
                <option value="geral">Requisições</option>
                <option value="modificacoes">Modificações</option>
                <option value="relatorio">Compliance</option>
              </select>
              <select value={limit} onChange={e => setLimit(Number(e.target.value))} className="form-control d-inline-block" style={{ width: 120 }}>
                {[25,50,100,200].map(n => <option key={n} value={n}>{n} linhas</option>)}
              </select>
            </div>
          </div>
        </div>
        {erro && <div className="alert alert-danger">{erro}</div>}
        {loading && <div className="alert alert-info">Carregando...</div>}
        {!loading && tab === 'geral' && (
          <div className="card">
            <div className="card-header">Requisições recentes (empresa {usuario?.cod_empresa})</div>
            <div className="card-body p-0">
              <div className="table-responsive" style={{ maxHeight: 500 }}>
                <table className="table table-sm table-striped table-hover mb-0">
                  <thead className="thead-dark">
                    <tr>
                      <th>ID</th>
                      <th>Data</th>
                      <th>Usuário</th>
                      <th>Recurso</th>
                      <th>Ação</th>
                      <th>Método</th>
                      <th>Status</th>
                      <th>Sucesso</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gerais.map(l => (
                      <tr key={l.id} className={l.sucesso ? '' : 'table-danger'}>
                        <td>{l.id}</td>
                        <td>{new Date(l.data_evento).toLocaleString()}</td>
                        <td>{l.usuario_id ?? '—'}</td>
                        <td>{l.recurso}</td>
                        <td>{l.acao}</td>
                        <td>{l.metodo}</td>
                        <td>{l.status_code}</td>
                        <td>{l.sucesso ? '✅' : '❌'}</td>
                      </tr>
                    ))}
                    {gerais.length === 0 && <tr><td colSpan={8} className="text-center">Sem registros</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {!loading && tab === 'modificacoes' && (
          <div className="card">
            <div className="card-header">Modificações recentes</div>
            <div className="card-body p-0">
              <div className="table-responsive" style={{ maxHeight: 500 }}>
                <table className="table table-sm table-striped table-hover mb-0">
                  <thead className="thead-dark">
                    <tr>
                      <th>ID</th>
                      <th>Data</th>
                      <th>Recurso</th>
                      <th>Operação</th>
                      <th>Usuário</th>
                      <th>Sucesso</th>
                      <th>Campos</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mods.map(m => (
                      <tr key={m.id} className={m.sucesso ? '' : 'table-danger'}>
                        <td>{m.id}</td>
                        <td>{new Date(m.data_evento).toLocaleString()}</td>
                        <td>{m.recurso}</td>
                        <td>{m.operacao}</td>
                        <td>{m.usuario_id ?? '—'}</td>
                        <td>{m.sucesso ? '✅' : '❌'}</td>
                        <td>{m.campos_alterados ? Object.keys(m.campos_alterados).length : 0}</td>
                      </tr>
                    ))}
                    {mods.length === 0 && <tr><td colSpan={7} className="text-center">Sem registros</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {!loading && tab === 'relatorio' && (
          <div className="card">
            <div className="card-header">Relatório de Compliance</div>
            <div className="card-body p-0">
              <table className="table table-sm table-striped mb-0">
                <thead className="thead-dark">
                  <tr>
                    <th>Categoria</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {relatorio.map((r: any, i) => (
                    <tr key={i}>
                      <td>{r.tipo}</td>
                      <td>{r.total}</td>
                    </tr>
                  ))}
                  {relatorio.length === 0 && <tr><td colSpan={2} className="text-center">Sem dados</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default LogsAuditoria;
